@let isLoading = isLoadingSg();

<div class="atn-cluster-functional-usage">
  <atn-ds-widget title="Functional Usage">
    <ng-container actions>
      <button
        class="atn-cluster-functional-usage__edit-button"
        [disabled]="isLoading"
        (click)="editClickHandler()"
      >
        <i class="atn-icon atn-edit atn-blue"></i>
      </button>
    </ng-container>

    @if (!isLoading) {
      @let allAllocations = allAllocationsSg();
      @let functionalUsageChartData = functionalUsageChartDataSg();

      <div class="atn-cluster-functional-usage__content">
        <atn-space-functional-usage-functionalizations
          [allocations]="allAllocations"
          [chartData]="functionalUsageChartData"
        />
      </div>
      @let functionalUsageWarning =
        clusterWarningsPlugin.selectors
          .getMessage(WarningCode.MissingFunctionalUsagesForSelectedAccounts)
          .asSignal();

      @if (functionalUsageWarning) {
        <div class="atn-cluster-functional-usage__notice">
          <atn-ds-notice
            [style]="DisplayStyle.Warning"
            [description]="functionalUsageWarning"
          />
        </div>
      }
    } @else {
      <div class="atn-cluster-functional-usage__loader">
        <atn-ds-loader />
      </div>
    }
  </atn-ds-widget>
</div>

<atn-space-cluster-functional-usage-modal />
